<template>
	<div class="login-vue" :style="bg">
		<div class="container">
			<p class="title">
				<img style="width:30px;margin-right:10px" src="../assets/imgs/logo.gif" />山东拙诚智能科技
			</p>
			<div class="input-c">
				<Input prefix="ios-contact" v-model="account" placeholder="用户名" clearable />
				<p class="error">{{accountError}}</p>
			</div>
			<div class="input-c">
				<Input type="password" v-model="pwd" prefix="md-lock" placeholder="密码" clearable @keyup.enter.native="enter" />
				<p class="error">{{pwdError}}</p>
			</div>
			<Button :loading="isShowLoading" class="submit" type="primary" @click="submit">登录</Button>
			<!-- <p class="account"><span @click="register">注册账号</span> | <span @click="forgetPwd">忘记密码</span></p> -->
		</div>
	</div>
</template>

<script>
	import {
		menusToRoutes
	} from '../utils'
	export default {
		name: "login",
		data() {
			return {
				account: "",
				pwd: "",
				accountError: "",
				pwdError: "",
				isShowLoading: false,
				bg: {}
			};
		},
		created() {
			this.bg.backgroundImage =
				"url(" +
				require("../assets/imgs/bg0" + new Date().getDay() + ".jpg") +
				")";
		},
		watch: {
			$route: {
				handler: function(route) {
					this.redirect = route.query && route.query.redirect;
				},
				immediate: true
			}
		},
    mounted() {
      let cs = window.location.href.split('?')[1];//获取?之后的参数字符串
      if(cs !== undefined){
        let cs_arr = cs.split('&');//参数字符串分割为数组
        console.log(cs_arr);
        cs = {};
        for (var i = 0; i < cs_arr.length; i++) {//遍历数组，拿到json对象
          cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
        }
        if (cs.account != undefined && cs.pwd != undefined) {
          this.account = cs.account;
          this.pwd = cs.pwd;
          console.log(cs);
          this.submit();
        }
      }
    },
		methods: {
			enter() {
				this.submit();
			},
			verifyAccount(e) {
				if (this.account !== "admin") {
					this.accountError = "请输入账号";
				} else {
					this.accountError = "";
				}
			},
			verifyPwd(e) {
				if (this.pwd !== "admin") {
					this.pwdError = "请输入密码";
				} else {
					this.pwdError = "";
				}
			},
			register() {
				console.log("注册账号");
			},
			forgetPwd() {
				console.log("忘记密码");
			},
			genMenu(obj, permissions) {
				var resultArray = [];
				for (let i = 0; i < obj.length; i++) {
					let temp = obj[i];
					if (temp.name) {
						resultArray.push(temp);
					} else {
						if (temp.children) {
							let currentNode = temp;
							let newChildrenArray = [];
							let childrenArray = temp.children;
							for (let i = 0; i < childrenArray.length; i++) {
								if (permissions.indexOf(childrenArray[i].name) >= 0) {
									newChildrenArray.push(childrenArray[i]);
								}
							}

							if (newChildrenArray.length > 0) {
								currentNode.children = newChildrenArray;
								resultArray.push(currentNode);
							}
						}
					}
				}

				return resultArray;
			},
			submit() {
				this.isShowLoading = true;
				var that = this;
				$.ajax({
					url: "/api/Login",
					contentType: "application/json",
					type: "post",
					dataType: "json",
					data: JSON.stringify({
						userAccount: that.account,
						password: that.pwd
					}),
					success: function(data) {
						if (data.errorCode != 0) {
							that.$Notice.error({
								title: "异常",
								desc: "用户信息获取异常"
							});
							that.result = "fail";
							return;
						}

						if (data.body.userInfo == undefined || data.body.userInfo.length == 0) {
							that.$Notice.warning({
								title: "用户名或密码错误"
							});
						} else {
							// 登录成功 设置用户信息
							localStorage.setItem("userImg", "../imgs/logo.jpg");
							localStorage.setItem("userAccount", that.account);
							if (data.body.isAdmin == "1") {
								localStorage.setItem("userName", "超级管理员");
								localStorage.setItem("isAdmin", 'true');
							} else {
								localStorage.setItem(
									"userName",
									data.body.userInfo.personnelName
								);
								localStorage.setItem("isAdmin", 'false');
							}
							localStorage.setItem("personnelGroverningBodyId", data.body.userInfo
								.personnelGroverningBodyId);
							localStorage.setItem("permissions", data.body.permissions);
							console.log(data.body.permissions);
							// 登录成功 假设这里是后台返回的 token
							localStorage.setItem("token", "i_am_token");

							that.$router.push({
								path: that.redirect || "/"
							});
						}
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "用户信息获取异常"
						});
						that.result = "fail";
					},
					complete: function(XMLHttpRequest, textStatus) {
						that.isShowLoading = false;
					}
				});
			}
		}
	};
</script>

<style>
	.login-vue {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #fff;
	}

	.login-vue .container {
		background: rgba(255, 255, 255, 0.5);
		width: 300px;
		text-align: center;
		border-radius: 10px;
		padding: 30px;
	}

	.login-vue .ivu-input {
		background-color: transparent;
		color: #fff;
		outline: #fff;
		border-color: #fff;
	}

	.login-vue ::-webkit-input-placeholder {
		/* WebKit, Blink, Edge */
		color: rgba(255, 255, 255, 0.8);
	}

	.login-vue :-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: rgba(255, 255, 255, 0.8);
	}

	.login-vue ::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: rgba(255, 255, 255, 0.8);
	}

	.login-vue :-ms-input-placeholder {
		/* Internet Explorer 10-11 */
		color: rgba(255, 255, 255, 0.8);
	}

	.login-vue .title {
		font-size: 16px;
		margin-bottom: 20px;
	}

	.login-vue .input-c {
		margin: auto;
		width: 200px;
	}

	.login-vue .error {
		color: red;
		text-align: left;
		margin: 5px auto;
		font-size: 12px;
		padding-left: 30px;
		height: 20px;
	}

	.login-vue .submit {
		width: 200px;
	}

	.login-vue .account {
		margin-top: 30px;
	}

	.login-vue .account span {
		cursor: pointer;
	}

	.login-vue .ivu-icon {
		color: #eee;
	}

	.login-vue .ivu-icon-ios-close-circle {
		color: #777;
	}
</style>
